module.exports = __webpack_public_path__ + "img/banner-principal.a9dd76d8.png";